import type { DottedName } from '@incubateur-ademe/nosgestesclimat'

export const orderedCategories: DottedName[] = [
  'transport',
  'alimentation',
  'logement',
  'divers',
  'services sociétaux',
]
